import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./App.css";
// QueryClient, QueryClientProvider

import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Toaster from "./components/ui/toaster";
import { TooltipProvider } from "./components/ui/tooltip";

// Import individual components for separate routes
import Hero from "./components/Hero";
// import Portfolio from "./components/Portfolio";
import TrustedBy from "./components/TrustedBy";
// import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Navigation from "./components/Navigation";
import About from "./components/About";

import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Cookies from "./pages/Cookies";
import ThreeDWork from "./pages/threeD-work";
import Visuals from "./pages/visuals-work";
import Photography from "./pages/photography-work";
import GraphicDesign from "./pages/graphic-design-work";
import PortfolioPage from "./pages/PortfolioPage";
import ContactPage from "./pages/ContactPage";
import ScrollToTop from "./components/ScrollToTop";

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Navigation />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Home page */}
            <Route path="/" element={<Index />} />

            {/* Portfolio Pages */}
            <Route path="/portfolio/3d-work" element={<ThreeDWork />} />
            <Route path="/portfolio/visual-effects" element={<Visuals />} />
            <Route path="/portfolio/photography" element={<Photography />} />
            <Route path="/portfolio/graphic-design" element={<GraphicDesign />} />

            {/* Individual component routes */}
            <Route path="/navigation" element={<Navigation />} />
            <Route path="/hero" element={<Hero />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/trusted-by" element={<TrustedBy />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/footer" element={<Footer />} />
            <Route path="/about" element={<About />} />

            {/* Footer */}
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/cookies" element={<Cookies />} />


            {/* Catch-all 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};


export default App;

// add route in App.js for Contact, Footer, Hero, Navigation, Portfolio, and TrustedBy components
